__webpack_require__.p = "/js/blesk-zpravy/dist/";